import { ArrowLeft } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";

export function ErrorPage() {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleDashboardClick = () => {
    window.location.href = "https://pollinator.coop";
  };

  const handleHomepageClick = () => {
    window.location.href = "https://www.pollinator.coop";
  };

  return (
    <div className="-mt-16 min-h-[100dvh] p-16">
      <div className="flex h-full min-h-[100dvh] flex-col justify-center">
        <div className="w-full max-w-2xl text-left px-8">
          <div className="flex flex-col border-b border-brand-800 pb-8">
            <div className="flex flex-col gap-4 md:gap-8">
              <Type variant="h1">Something went wrong</Type>

              <Type variant="body1" className="text-brand-700">
                An error occurred. Please try again later.
              </Type>

              <div className="flex max-w-sm flex-col">
                <Button
                  onClick={handleGoBack}
                  className="flex w-fit"
                  iconComponent={ArrowLeft}
                >
                  Go back
                </Button>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-8 md:gap-16 py-8 md:flex-row">
            <div className="flex flex-col gap-1">
              <Type variant="h4" as="h2">Sending Institutions</Type>
              <Type variant="body2" className="text-brand-700 mb-2">
                pollinator.coop
              </Type>
              <Button
                onClick={handleDashboardClick}
                variant="secondary"
                className="w-fit"
              >
                Go to my Dashboard
              </Button>
            </div>

            <div className="flex flex-col gap-1">
              <Type variant="h4" as="h2">General Visitors</Type>
              <Type variant="body2" className="text-brand-700 mb-2">
                www.pollinator.coop
              </Type>
              <Button
                onClick={handleHomepageClick}
                variant="secondary"
                className="w-fit"
              >
                Go to the homepage
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
